/* eslint-disable no-unused-vars */
import React from "react";
import "./sidebar.scss";
import Dropdown from "./Dropdown";
import {
  baseballData,
  cricketData,
  footbalData,
  systemData,
  tennisData,
  basketballData,
  hockeyData,
  handballData,
  feildHockeyData,
  volleyballData,
  SnookerData,
  americanFootballData,
  floorBall,
  rugbyData,
  golfData,
  rugbyUnionData,
  rugbyLeagueData,
  mmaData,
  tableTennisData,
  oddsMappingData,
  motorsportData,
  horseRacingData
} from "./helper";
import { ReactComponent as CricIcon } from "assets/svg/cricketIcon.svg";
import { ReactComponent as TennisBall } from "assets/svg/tennisBall.svg";
import { ReactComponent as SystemSvg } from "assets/svg/system.svg";
import { ReactComponent as FootballSvg } from "assets/svg/football.svg";
import { ReactComponent as Floorball } from "assets/svg/Floorball.svg";
import { ReactComponent as BasketballSvg } from "assets/svg/basketball.svg";
import { ReactComponent as IceHockey } from "assets/svg/IceHockey.svg";
import { ReactComponent as FeildHockey } from "assets/svg/feildHockey.svg";
import { ReactComponent as Handball } from "assets/svg/handball.svg";
import { ReactComponent as Volleyball } from "assets/svg/volleyball.svg";
import { ReactComponent as Snooker } from "assets/svg/snooker.svg";
import { ReactComponent as RugbyIcon } from "assets/svg/rugby.svg";
import { ReactComponent as AmericanFootball } from "assets/svg/americanFootball.svg";
import { ReactComponent as Golf } from "assets/svg/golf.svg";
import { useState } from "react";
import { useEffect } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { toLower } from "lodash";
// import img1 from "../../assets/imgs/img1.png";

// import {
//   faEye,
//   faPencil,
//   faTrash,
//   faCircle,
//   faTableTennis,
//   amazon,
// } from "@fortawesome/free-solid-svg-icons";



function SideB() {
  const loc = useLocation();

  const auth = useSelector((x) => x.auth.value);
  // const ops = window.location.pathname.split("/");
  const [searchParams] = useSearchParams();
  const sport = searchParams.get("sport");
  const [currentMenu, setCurrentMenu] = useState(
    // ops.length > 0 ? (ops[1] ? ops[1] : "") : ""
    toLower(sport)
  );
  useEffect(() => {
    let active = searchParams.get("sport");
    if (!active) {
      if (loc.pathname.includes("odds-mapping")) {
        active = "oddsmapping";
      } else {
        active = "systemdata";
      }
    }
    setCurrentMenu(toLower(active));
  }, [searchParams, sport, loc.pathname]);

  return (
    <div id="layoutSidenav">
      <div id="layoutSidenav_nav">
        <nav
          className="sb-sidenav accordion sb-sidenav-dark"
          id="sidenavAccordion"
        >
          <div className="sb-sidenav-menu">
            <Dropdown
              title="Football"
              list={footbalData}
              status={currentMenu === "football" ? true : false}
              currentMenu={currentMenu}
              setCurrentMenu={setCurrentMenu}
              name="football"
            >
              <FootballSvg className="me-1" />
            </Dropdown>

            <Dropdown
              title="Tennis"
              list={tennisData}
              status={false}
              currentMenu={currentMenu}
              setCurrentMenu={setCurrentMenu}
              name="tennis"
            >
              <TennisBall className="me-1" />
            </Dropdown>

            <Dropdown
              title="Basketball"
              list={basketballData}
              status={false}
              currentMenu={currentMenu}
              setCurrentMenu={setCurrentMenu}
              name="basketball"
            >
              <BasketballSvg className="me-1" />
            </Dropdown>

            <Dropdown
              title="Ice Hockey"
              list={hockeyData}
              status={false}
              currentMenu={currentMenu}
              setCurrentMenu={setCurrentMenu}
              name="hockey"
            >
              <IceHockey className="me-1" />
            </Dropdown>

            <Dropdown
              title="Handball"
              list={handballData}
              status={false}
              currentMenu={currentMenu}
              setCurrentMenu={setCurrentMenu}
              name="handball"
            >
              <Handball className="me-1" />
            </Dropdown>

            {/* <Dropdown
              title="Field Hockey"
              list={feildHockeyData}
              status={false}
              currentMenu={currentMenu}
              setCurrentMenu={setCurrentMenu}
              name="field-hockey"
            >
              <FeildHockey className="me-1" />
            </Dropdown> */}

            <Dropdown
              title="Volleyball"
              list={volleyballData}
              status={false}
              currentMenu={currentMenu}
              setCurrentMenu={setCurrentMenu}
              name="volleyball"
            >
              <Volleyball className="me-1" />
            </Dropdown>

            {/* <Dropdown
              title="Snooker"
              list={SnookerData}
              status={currentMenu === "snooker" ? true : false}
              currentMenu={currentMenu}
              setCurrentMenu={setCurrentMenu}
              name="snooker"
            >
              <Snooker className="me-1 snooker_svg" />
            </Dropdown> */}

            <Dropdown
              title="American Football"
              list={americanFootballData}
              status={false}
              currentMenu={currentMenu}
              setCurrentMenu={setCurrentMenu}
              name="american-football"
            >
              <AmericanFootball className="me-1" />
            </Dropdown>

            {/* <Dropdown
              title="Floorball"
              list={floorBall}
              status={currentMenu === "floorball" ? true : false}
              currentMenu={currentMenu}
              setCurrentMenu={setCurrentMenu}
              name="floorball"
            >
              <Floorball className="me-1" />
            </Dropdown> */}

            <Dropdown
              title="Rugby League"
              list={rugbyLeagueData}
              status={currentMenu === "rugby-league" ? true : false}
              currentMenu={currentMenu}
              setCurrentMenu={setCurrentMenu}
              name="rugby-league"
            >
              <RugbyIcon className="me-1" />
            </Dropdown>
            <Dropdown
              title="Rugby Union"
              list={rugbyUnionData}
              status={currentMenu === "rugby-union" ? true : false}
              currentMenu={currentMenu}
              setCurrentMenu={setCurrentMenu}
              name="rugby-union"
            >
              <RugbyIcon className="me-1" />
            </Dropdown>

            <Dropdown
              title="Golf"
              list={golfData}
              status={currentMenu === "golf" ? true : false}
              currentMenu={currentMenu}
              setCurrentMenu={setCurrentMenu}
              name="golf"
            >
              <Golf className="me-1" />
            </Dropdown>

            {/* <Dropdown
              title="Cricket"
              list={cricketData}
              status={currentMenu === "cricket" ? true : false}
              currentMenu={currentMenu}
              setCurrentMenu={setCurrentMenu}
              name="cricket"
            >
              <CricIcon className="me-1" />
            </Dropdown> */}
            <Dropdown
              title="Baseball"
              list={baseballData}
              status={currentMenu === "baseball" ? true : false}
              currentMenu={currentMenu}
              setCurrentMenu={setCurrentMenu}
              name="baseball"
            >
              <TennisBall className="me-1" />
            </Dropdown>
             <Dropdown
              title="MMA"
              list={mmaData}
              status={currentMenu === "mma" ? true : false}
              currentMenu={currentMenu}
              setCurrentMenu={setCurrentMenu}
              name="mma"
            >
              <TennisBall className="me-1" />
            </Dropdown>

            <Dropdown
              title="Table Tennis"
              list={tableTennisData}
              status={currentMenu === "table-tennis" ? true : false}
              currentMenu={currentMenu}
              setCurrentMenu={setCurrentMenu}
              name="table-tennis"
            >
              <TennisBall className="me-1" />
            </Dropdown>

             <Dropdown
              title="Motor Sport"
              list={motorsportData}
              status={currentMenu === "motorsport" ? true : false}
              currentMenu={currentMenu}
              setCurrentMenu={setCurrentMenu}
              name="motorsport"
            >
              <TennisBall className="me-1" />
            </Dropdown>

            <Dropdown
              title="Horse Racing"
              list={horseRacingData}
              status={currentMenu === "horse-racing" ? true : false}
              currentMenu={currentMenu}
              setCurrentMenu={setCurrentMenu}
              name="horse-racing"
            >
              <TennisBall className="me-1" />
            </Dropdown>

            <Dropdown
              title="Odds Management"
              list={oddsMappingData}
              status={false}
              currentMenu={currentMenu}
              setCurrentMenu={setCurrentMenu}
              name="oddsmapping"
            >
              <SystemSvg className="me-1" />
            </Dropdown>

            <Dropdown
              title="System Data"
              list={
                auth?.roles?.includes("ADMIN")
                  ? systemData
                  : [
                      {
                        title: "Tv Channel",
                        path: "/tv-channels",
                      },
                    ]
              }
              status={false}
              currentMenu={currentMenu}
              setCurrentMenu={setCurrentMenu}
              name="systemdata"
            >
              <SystemSvg className="me-1" />
            </Dropdown>

            {/* <Dropdown title="System Data" list={systemData} status={false}  /> */}
          </div>
        </nav>
      </div>
    </div>
  );
}
export default SideB;
